import React from 'react';
import Dialog from '@mui/material/Dialog';
import IconButton from '@mui/material/IconButton';
import { X } from 'lucide-react';
import { INLINE } from '../generated/inlineImages';
import { REGISTRATION_FORM_URL } from '../constants/links';

interface FlyerModalProps {
  open: boolean;
  onClose: () => void;
}

const FlyerModal: React.FC<FlyerModalProps> = ({ open, onClose }) => {
  return (
    <Dialog
      open={open}
      onClose={onClose}
      maxWidth="sm"
      scroll="body"
      aria-labelledby="flyer-modal-title"
      slotProps={{
        backdrop: {
          sx: {
            backgroundColor: 'rgba(26, 35, 50, 0.72)',
            backdropFilter: 'blur(10px)',
          },
        },
        paper: {
          sx: {
            backgroundColor: 'transparent',
            boxShadow: 'none',
            overflow: 'visible',
            maxWidth: 420,
          },
        },
      }}
    >
      <h2 id="flyer-modal-title" className="sr-only">
        Flyer — II Cumbre Nacional de Cristianos Políticos
      </h2>
      <IconButton
        onClick={onClose}
        aria-label="Cerrar modal"
        sx={{
          position: 'absolute',
          top: -12,
          right: -12,
          zIndex: 2,
          backgroundColor: '#FAFAF7',
          boxShadow: '0 8px 24px rgba(26, 35, 50, 0.2)',
          '&:hover': { backgroundColor: '#E84721', color: '#FAFAF7' },
        }}
      >
        <X size={20} />
      </IconButton>
      <a
        href={REGISTRATION_FORM_URL}
        target="_blank"
        rel="noopener noreferrer"
        className="flyer-modal-link"
        onClick={onClose}
      >
        <img
          src={INLINE.flyer}
          alt="Flyer de la II Cumbre Nacional de Cristianos Políticos, Lima 2026"
          className="flyer-image"
        />
      </a>
    </Dialog>
  );
};

export default FlyerModal;
